import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';
import { InsertReviewDto } from '@/api/requests/DTOS';

export const insertReview = async (body: InsertReviewDto) => {
  return await apiClient.post(`${ENDPOINTS.BOOKINGS}/review`, body);
};
